<template functional>
  <span>{{
    $options.profQualificationNames(props.personProfQualifications)
  }}</span>
</template>
<script>
import gql from "fraql";
export default {
  name: "AppShowPersonProfQualificationsList",
  props: {
    personProfQualifications: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  fragments: {
    personProfQualification: gql`
      fragment _ on PersonProfQualification {
        id
        validFrom
        validUntil
        profQualificationId
        profQualification @client {
          id
          name
        }
      }
    `,
    person: gql`
      fragment _ on Person {
        id
        personProfQualifications {
          id
          validFrom
          validUntil
          profQualificationId
          profQualification @client {
            id
            name
          }
        }
      }
    `
  },
  profQualificationNames(personProfQualifications) {
    return personProfQualifications
      .map(p => p?.profQualification?.name ?? null)
      .filter(Boolean)
      .join(", ");
  }
};
</script>
